import {
//	BrowserRouter as Router,
//	Switch,
//	Route,
//	Link,
	useRouteMatch,
	useParams,
	useLocation,
	useHistory
} from "react-router-dom";
import React, { useRef, useState, useEffect, createRef } from "react";

import { createEtc3001CynageLinkList, updateEtc3001CynageLinkList, deleteEtc3001CynageLinkList } from "../graphql/mutations";
import { getEtc3001CynageLinkList, listEtc3001CynageLinkLists } from "../graphql/queries";
import { createEtc3001CynageSequence, updateEtc3001CynageSequence, deleteEtc3001CynageSequence } from "../graphql/mutations";
import { updateExEtc3001CynageSequence } from "../graphql/mutations";
import { getEtc3001CynageSequence, listEtc3001CynageSequences } from "../graphql/queries";

import * as common from "./common";
import * as database from "./database";

import TopNav from "./TopNav";

import {
	Breadcrumb,
	Button,
	Container
} from "react-bootstrap";


// Component ===================================================================

function LinkListAddConfirm ( props )
{
	const routeMatch = useRouteMatch();
	const location = useLocation();
	const params = useParams();
	const history = useHistory();

	//console.log( "LinkListAddConfirm > LinkListAddConfirm () props : " + JSON.stringify( props ) );
	//console.log( "LinkListAddConfirm > LinkListAddConfirm () routeMatch : " + JSON.stringify( routeMatch ) );
	//console.log( "LinkListAddConfirm > LinkListAddConfirm () location : " + JSON.stringify( location ) );
	//console.log( "LinkListAddConfirm > LinkListAddConfirm () params : " + JSON.stringify( params ) );

	// 更新不要な DOM のフックを取得 (※ グローバルなスコープ場所では定義不可)
	// 更新可能な DOM のフックを取得 (※ グローバルなスコープ場所では定義不可)
	const [ addLinkListDisabled, setAddLinkListDisabled ] = useState( false );

	// 遅延実行処理
	// ※ 非同期処理(awaitの記述不要)はここで実行すること … ここで実行しないと何度も実行されてしまう
	useEffect( function ()
	{
		// ページタイトル設定
		document.title = common.PAGE_TITLE + " [リンクリスト(新規追加確認)]";
	}, [] );

	// 新規作成ページへ戻る処理
	const goBackPrevious = function ( event )
	{
		// クエリパラメータ作成
		const param = {
			pathname: "/component/LinkListAdd",
			//search: "",
			//hash: "",
			state: {
				name: location.state.name,
				link: location.state.link,
				icon: location.state.icon
			}
		};
		// 遷移
		history.push( param );
	};

	// リンクリスト追加登録処理
	// ※ 非同期の重い処理が含まれているので、<form onSubmit={ addLinkList }>では処理不可(ページ遷移が先行しエラーとなる)
	const addLinkList = async function ( event )
	{
		// データを保存中でない場合
		if ( !addLinkListDisabled )
		{
			// 保存ボタンの無効化
			setAddLinkListDisabled( true );

			// シーケンスデータ数値取得(非同期)
			const count = await common.getSequenceValue(
				getEtc3001CynageSequence,
				createEtc3001CynageSequence,
				updateExEtc3001CynageSequence,
				props.userData.domain.id,
				"LinkList",
				"order",
				1
			);

			//console.log( "LinkListAddConfirm > addLinkList () count : " + JSON.stringify( count ) );

			// シーケンスデータ数値の取得に成功した場合
			if ( 0 <= count )
			{
				// リンクリストデータ生成
				const input = {
					order: count,
					name: location.state.name,
					link: location.state.link,
					icon: location.state.icon || null,
					domainID: props.userData.domain.id
				};
				const response = await database.mutationCreate( createEtc3001CynageLinkList, input );

				//console.log( "LinkListAddConfirm > addLinkList () response : " + JSON.stringify( response ) );

				// リンクリストデータの生成に成功した場合
				if ( response )
				{
					// 遷移
					history.push( "/component/LinkListAddComplete" );
				}
				// リンクリストデータの生成に失敗した場合
				else
				{
					console.error( "LinkListAddConfirm > addLinkList () link list data create error." );
				}
			}
			// シーケンスデータ数値の取得に失敗した場合
			else
			{
				console.error( "LinkListAddConfirm > addLinkList () sequence value (LinkList.order) get error." );
			}
		}
	};

	return (
		<>

			{/* ヘッダー部 */}
			<div className="right_header bg-light">

				<Breadcrumb className="breadcrumb_list">
					<Breadcrumb.Item onClick={ () => history.push( "/component/LinkList" ) }>リンクリスト</Breadcrumb.Item>
					<Breadcrumb.Item active>新規作成 (確認)</Breadcrumb.Item>
				</Breadcrumb>

				<TopNav />

			</div>

			{/* メイン部 */}
			<Container fluid className="main_container">

				<h4 className="mb-4">
					リンク新規作成 (確認)
				</h4>

				<div>
					(1) リンクの名前 (全角36文字以内)<br className="wide_br" />
					<p className="ms-3">{ location.state.name }</p>
				</div>

				<div>
					(2) リンク先URL<br className="wide_br" />
					<p className="ms-3"><a href={ location.state.link } target="_blank">{ location.state.link }</a></p>
				</div>

				<div>
					(3) アイコン画像URL<br className="wide_br" />
					<p className="ms-3">
					{
						( location.state.icon ) ?
						<>
							<a href={ location.state.icon } target="_blank">
								<img src={ location.state.icon } alt="" width="64" height="64" /><br />
								{ location.state.icon }
							</a>
						</> :
						"無し"
					}
					</p>
				</div>

				<div className="mt-5 mb-2 d-flex justify-content-center action_btn_group">
					<Button variant="secondary" onClick={ goBackPrevious }>修正</Button>
					<Button onClick={ addLinkList } disabled={ addLinkListDisabled }>保存</Button>
				</div>

			</Container>

		</>
	);
}

export default LinkListAddConfirm;
